import { OnboardingStep } from '../enums/onboardingStep'
import { OnboardingSetupStep } from '../types'

export const onboardingStepToPath: Record<OnboardingSetupStep, OnboardingStep> = {
  ACCOUNTING_MANAGEMENT: OnboardingStep.AccountingManagement,
  INTENT: OnboardingStep.Intent,
  INVOICES: OnboardingStep.Invoices,
  NAME_PHONE: OnboardingStep.NamePhone,
  WORK_STYLE: OnboardingStep.WorkStyle,
}

export const onboardingPathToStep: Record<string, OnboardingSetupStep> = Object.fromEntries(
  Object.entries(onboardingStepToPath).map(([step, path]) => [path, step as OnboardingSetupStep]),
)
